"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));

var _Link = _interopRequireDefault(require("@sprinx/react-mui-components/Link"));

var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _MainNavigationItemPopoverNestItem = _interopRequireDefault(require("@sprinx/react-web/MainNavigationItemPopoverNestItem"));

var _MainNavigationItemPopoverNest = _interopRequireDefault(require("./MainNavigationItemPopoverNest"));

var _MainNavigationNestItem = _interopRequireDefault(require("./MainNavigationNestItem"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%'
    },
    panelSummary: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      margin: 0
    },
    nest: {
      alignItems: 'center'
    },
    fullWidth: {
      width: '100%'
    },
    listItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& > div:last-of-type': {
        minWidth: 'auto'
      }
    },
    closedLink: {
      color: theme.palette.text.primary,
      paddingLeft: theme.spacing(1)
    },
    text: {
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: 0
    },
    links: {
      flexDirection: 'column',
      paddingLeft: theme.spacing(3)
    },
    popoverItem: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingLeft: 0,
      paddingRight: 0,
      '&:not(:last-child)': {
        borderRight: 'none',
        paddingRight: theme.spacing(2)
      },
      '&:not(:first-child)': {
        paddingLeft: 0
      }
    }
  };
}, {
  name: 'MobileMainNavigation'
});

var _ref2 = /*#__PURE__*/_react.default.createElement(_ExpandLess.default, null);

var _ref3 = /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null);

function MobileMainNavigation(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      menuItems = _ref.menuItems,
      setOpen = _ref.setOpen,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "menuItems", "setOpen"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();

  var _React$useState = _react.default.useState(null),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      collapse = _React$useState2[0],
      setCollapse = _React$useState2[1];

  var handleCollapse = function handleCollapse(i, v) {
    return function () {
      if (v.items) {
        setCollapse(function (s) {
          return s === i ? null : i;
        });
      }

      return null;
    };
  };

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), (menuItems || []).map(function (i, idx) {
    return /*#__PURE__*/_react.default.createElement(_List.default, {
      key: idx.toString()
    }, /*#__PURE__*/_react.default.createElement(_ListItem.default, {
      divider: collapse !== idx,
      classes: {
        content: classes.panelSummary
      },
      onClick: handleCollapse(idx, i),
      className: classes.listItem
    }, /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, null, /*#__PURE__*/_react.default.createElement(_MainNavigationNestItem.default, {
      size: "small",
      src: i.image,
      shape: "square"
    })), /*#__PURE__*/_react.default.createElement(_ListItemText.default, null, /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: classes.closedLink,
      to: i.href,
      onClick: function onClick() {
        return setOpen(false);
      }
    }, t(i.label))), Boolean(i.items && i.items.length) && /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, null, collapse === idx ? _ref2 : _ref3)), Boolean(i.items && i.items.length) && /*#__PURE__*/_react.default.createElement(_Collapse.default, {
      in: collapse === idx,
      unmountOnExit: true
    }, i.items.map(function (s, index) {
      return /*#__PURE__*/_react.default.createElement(_MainNavigationItemPopoverNest.default, {
        label: t(s.label),
        href: s.href,
        key: index.toString(),
        onClick: function onClick() {
          return setOpen(false);
        },
        classes: {
          root: (0, _clsx.default)(classes.fullWidth, !(s.items && s.items.length) && classes.nest),
          links: classes.links,
          text: classes.text
        }
      }, s.items && s.items.length ? s.items.map(function (ss, sidx) {
        return /*#__PURE__*/_react.default.createElement(_MainNavigationItemPopoverNestItem.default, {
          classes: {
            root: classes.popoverItem
          },
          key: sidx.toString(),
          href: ss.href,
          onClick: function onClick() {
            return setOpen(false);
          }
        }, t(ss.label));
      }) : null);
    })));
  }));
}

process.env.NODE_ENV !== "production" ? MobileMainNavigation.propTypes = {
  appBarActions: _propTypes.default.shape({}),
  classes: _propTypes.default.shape({
    closedLink: _propTypes.default.string,
    fullWidth: _propTypes.default.string,
    links: _propTypes.default.string,
    listItem: _propTypes.default.string,
    nest: _propTypes.default.string,
    panelSummary: _propTypes.default.string,
    popoverItem: _propTypes.default.string,
    root: _propTypes.default.string,
    text: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  logo: _propTypes.default.func,
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({})).isRequired,
  setOpen: _propTypes.default.func
} : void 0;
MobileMainNavigation.defaultProps = {
  appBarActions: undefined,
  classes: undefined,
  className: undefined,
  logo: undefined,
  setOpen: undefined
};
var _default = MobileMainNavigation;
exports.default = _default;